import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VESSEL_TYPE } from "../../util/varibles/constants";
import { checkOpInSite, cloneObj } from "../../util/varibles/global";
import { IOperation, IOperations, ISite } from "../../util/varibles/interface";
import { createKeyOfNote, initialState } from "./constants";

const overviewSlice = createSlice({
    name: 'overview',
    initialState,
    reducers: {
        initialDataRequest: (state, _) => {
            state.loadingData = true;
        },
        initialDataSuccess: (state, action) => {
            const { result } = action.payload;
            let { operations, vessels, wellboats, level, notes, before_count: beforeCount, after_count: afterCount } = result;

            state.vessels = vessels
            state.wellboats = wellboats
            state.level = level;
            state.operations = operations

            state.notes = notes.reduce((rs: any, item: any) => {
                const { timestamp, level } = item;
                const key = createKeyOfNote(timestamp, level);
                rs[key] = [...rs[key] || [], item];
                return rs;
            }, {});
            state.beforeCount = beforeCount;
            state.afterCount = afterCount;
            state.loadingData = false;
        },
        initialDataFailure: (state) => {
            state.loadingData = false;
        },
        lazyLoadingRequest: (state, action) => {
            const { weeks, isLoad } = action.payload;
            if (isLoad)
                state.loadingLazy = true;
            else
                state.weeks = weeks;
        },
        lazyLoadingSuccess: (state, action) => {
            const { result, key, weeks } = action.payload;
            state.weeks = weeks;
            const { operations, vessels, wellboats, level } = result;
            state.operations = operations;
            state.vessels = vessels;
            state.wellboats = wellboats;
            state.level = level;
            state.loadingLazy = false;
            if (key === "beforeCount") {
                state.beforeCount = result.before_count;
            } else {
                state.afterCount = result.after_count;
            }
        },
        lazyLoadingFailure: (state) => {
            state.loadingLazy = false;
        },
        setShowAllPlans: (state, action: PayloadAction<boolean>) => {
            state.showAllPlans = action.payload;
        },
        updateOps: (_, __: PayloadAction<IOperation[]>) => { },
        deleteOps: (_, __: PayloadAction<string[]>) => { },
        addOps: (_, __: PayloadAction<IOperation[]>) => { },
        updateOperations: (state, action: PayloadAction<{ ops: typeof initialState.operations, level: typeof initialState.level }>) => {
            const { level } = action.payload;
            state.operations = action.payload.ops;
            state.level = level;
            state.vessels = state.vessels.map(item => {
                const { id: vesselId, row = 1 } = item;
                const max = Math.max(...Object.keys(level[vesselId] || {}).map(opId => level[vesselId][opId].sub), row);
                return { ...item, row: max }
            })
        },
        updateWellboatOperations: (state, action: PayloadAction<IOperations>) => {
            state.wellboats.operations = action.payload;
        },
        updateNotesCalendar: (state, action) => {
            const notes = action.payload;
            const { timestamp, level } = notes[0];
            const key = createKeyOfNote(timestamp, level);
            state.notes = { ...state.notes, [key]: notes }
        },
        deleteNotesCalendar: (state, action) => {
            const notes = action.payload;
            const { timestamp, level } = notes[0];
            const key = createKeyOfNote(timestamp, level);
            const { [key]: old, ...args } = state.notes;
            state.notes = args
        },
        updateVessels: (state, action) => {
            state.vessels = action.payload
        },
        updateSites: (state, action: PayloadAction<ISite[]>) => {
            state.sites = action.payload;
        },
        updateOpsSite: (state, action: PayloadAction<{ opsSite: IOperations, sites?: ISite[] }>) => {
            const { opsSite, sites } = action.payload
            if (sites)
                state.sites = sites;
            state.opsSite = { ...state.opsSite, ...opsSite };
        },
        updateOpsSiteByWs: (state, action: PayloadAction<IOperation[]>) => {
            const ops = action.payload;
            const result: Record<string, IOperation & { site_ids: string[] }> = {};
            const { vessels, sites } = state;
            const globalIds = new Set(sites.map(item => item.id))

            ops.forEach(item => {
                const { [item.operation.operation_type]: funcCheck } = checkOpInSite;
                if (!!funcCheck) {
                    const siteIds = funcCheck(item.operation, globalIds)
                    if (siteIds.length > 0) {
                        const { id, vessel_id } = item.operation;
                        const { name: vessel_name = "", type: vessel_type = VESSEL_TYPE.PROCESS_VESSEL } = vessels.find(v => v.id === vessel_id) || {};
                        result[id] = { ...item, operation: { ...item.operation, vessel_name, vessel_type }, site_ids: siteIds };
                    }
                }
            })
            state.opsSite = { ...state.opsSite, ...result };
        },
        deleteOpsSiteByWs: (state, action: PayloadAction<string[]>) => {
            let temp = cloneObj(state.opsSite);
            if (Object.keys(temp).length > 0) {
                const ids = action.payload;
                ids.forEach(id => {
                    const { [id]: _, ...args } = temp;
                    temp = { ...args };
                })
                state.opsSite = temp;
            }
        },
        saveOp: (_, action: PayloadAction<{ update?: IOperations, add?: IOperations }>) => {

        }
    },
})

export const overviewActions = overviewSlice.actions

const overviewReducer = overviewSlice.reducer;

export default overviewReducer;
